const translations = {
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading',
    name: 'Name',
    noBoundaries: 'No Boundaries',
    noMoreBoundaries: 'No More Boundaries'
};

export default translations;
